export const LOAD_SIDEBAR_CONVERSATION_SUCCESS = 'LOAD_SIDEBAR_CONVERSATION_SUCCESS';
export const LOAD_SIDEBAR_CONVERSATION_START = 'LOAD_SIDEBAR_CONVERSATION_START';
export const SEND_MESSAGE_ON_SIDEBAR_START = 'SEND_MESSAGE_ON_SIDEBAR_START';
export const SEND_MESSAGE_ON_SIDEBAR_SUCCESS = 'SEND_MESSAGE_ON_SIDEBAR_SUCCESS';
